var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterSm(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7323 3.70275C17.106 3.98025 16.4333 4.16775 15.726 4.2525C16.4558 3.81584 17.0017 3.1286 17.262 2.319C16.5764 2.72624 15.826 3.0129 15.0435 3.1665C14.5173 2.60465 13.8203 2.23225 13.0608 2.10711C12.3012 1.98197 11.5216 2.11109 10.8429 2.47444C10.1643 2.83779 9.62459 3.41502 9.30762 4.11653C8.99066 4.81803 8.91416 5.60456 9.09001 6.354C7.70077 6.28425 6.34173 5.92316 5.10108 5.29418C3.86042 4.6652 2.76589 3.78237 1.88851 2.703C1.58851 3.2205 1.41601 3.8205 1.41601 4.4595C1.41567 5.03475 1.55733 5.60118 1.82842 6.10855C2.0995 6.61592 2.49163 7.04853 2.97001 7.368C2.41522 7.35035 1.87266 7.20044 1.38751 6.93075V6.97575C1.38745 7.78256 1.66653 8.56453 2.1774 9.189C2.68826 9.81346 3.39944 10.2419 4.19026 10.4017C3.6756 10.541 3.13601 10.5616 2.61226 10.4618C2.83538 11.156 3.27001 11.763 3.85528 12.1979C4.44056 12.6329 5.1472 12.8739 5.87626 12.8872C4.63863 13.8588 3.11017 14.3858 1.53676 14.3835C1.25804 14.3836 0.979566 14.3673 0.702759 14.3347C2.29987 15.3616 4.15901 15.9066 6.05776 15.9045C12.4853 15.9045 15.999 10.581 15.999 5.964C15.999 5.814 15.9953 5.6625 15.9885 5.5125C16.672 5.01823 17.2619 4.40617 17.7308 3.705L17.7323 3.70275Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSm);
export default __webpack_public_path__ + "static/media/twitter-sm.e1b060c2bb1785e4e60a4593a7044faa.svg";
export { ForwardRef as ReactComponent };